export const extractJSONFromHTML = (htmlContent: string): string[] => {
  const jsonRegex = /{.*?}/g
  const parts = htmlContent.split(jsonRegex)
  const matches = htmlContent.match(jsonRegex) || []

  const result = [] as string[]
  for (let i = 0; i < parts.length; i++) {
    result.push(parts[i])
    if (matches[i]) {
      result.push(matches[i])
    }
  }
  return result
}
